
import { SET_TAB_DATA, SET_TAB_LOADER, SET_UPDATED_VALUES, SET_SKILLS, SET_SETTINGS, SET_MICROSITES, SET_MICROSITE_ACTIONS, SET_ACTIVE_PARTNER } from './constants'


export const setTabData = (tabData) => ({
    type: SET_TAB_DATA,
    tabData,
});

export const setTabLoader = (tabLoader) => ({
    type: SET_TAB_LOADER,
    tabLoader,
});

export const setUpdatedValues = (updatedValues) => ({
    type: SET_UPDATED_VALUES,
    updatedValues,
});


export const setSkills = (skills) => ({
    type: SET_SKILLS,
    skills,
});

export const setSettings = (settings) => ({
    type: SET_SETTINGS,
    settings,
});


export const setMicroSites = (microSites) => ({
    type: SET_MICROSITES,
    microSites,
});


export const setMicroSiteActions = (microSiteActions) => ({
    type: SET_MICROSITE_ACTIONS,
    microSiteActions,
});

export const setActivePartner = (activePartner) => ({
    type: SET_ACTIVE_PARTNER,
    activePartner,
});